// Tiny pub/sub connecting exercise session state to the goal progress bar,
// which lives in the persistent Layout shell above the game pages.

export interface SessionState {
  active: boolean
  idle: boolean
}

interface GoalBusEvents {
  // Fresh enriched goals from the backend (e.g. the /goals/report-progress response)
  'goals-updated': unknown[]
  // The current exercise session started/ended or went idle/resumed
  'session-state': SessionState
}

type Listener<E extends keyof GoalBusEvents> = (payload: GoalBusEvents[E]) => void

const listeners: { [E in keyof GoalBusEvents]: Set<Listener<E>> } = {
  'goals-updated': new Set(),
  'session-state': new Set(),
}

export function onGoalBus<E extends keyof GoalBusEvents>(event: E, fn: Listener<E>): () => void {
  listeners[event].add(fn)
  return () => listeners[event].delete(fn)
}

export function emitGoalBus<E extends keyof GoalBusEvents>(event: E, payload: GoalBusEvents[E]): void {
  listeners[event].forEach(fn => {
    try {
      fn(payload)
    } catch {}
  })
}
